import { Background } from '@appcharge/shared-ui';
import { Stack } from '@mui/material';
import { useMaintenanceMode } from '../../hooks/useMaintenanceMode';
import { StyledMaintenanceContent } from './style';

const LOGO_STYLE = { objectFit: 'contain' as const, maxWidth: '166px' };
const DEFAULT_MAINTENANCE_TEXT =
  "We're currently performing maintenance. Please check back soon.";

const hasContent = (html: string | undefined): boolean => {
  if (!html) return false;
  const textContent = html.replace(/<[^>]*>/g, '').trim();
  return textContent.length > 0;
};

const MaintenancePage = () => {
  const { sanitizedHtml, logo, fontColor, fontFamily, backgroundImageMobile, backgroundImageDesktop } =
    useMaintenanceMode();

  const content = hasContent(sanitizedHtml) ? sanitizedHtml : DEFAULT_MAINTENANCE_TEXT;
  return (
    <Background
      backgroundImageMobile={backgroundImageMobile}
      backgroundImageDesktop={backgroundImageDesktop}
      isStore
    >
      <Stack alignItems="center" justifyContent="center" height="100vh" p={4} gap={3}>
        {logo && <img src={logo} alt="logo" style={LOGO_STYLE} />}
        <StyledMaintenanceContent
          fontFamily={fontFamily}
          fontColor={fontColor}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </Stack>
    </Background>
  );
};

export default MaintenancePage;
